// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SamlLanding_buttonContainer__86Crm"};